export enum TickerAssetType {
	All = -1,
	Stocks,
	Crypto,
	Indices,
	FX,
	OTC,
	Formula,
	Commodities,
	Etf
}
export enum ExchangeType {
	All = -1,
	None = 0,
	PIO = 1,
	DC,
	FM,
	RF,
	PS,
	IM,
	EOD,
	CC,
	BN
}

export interface UserTickerInfo {
	id: string;
	name: string;
	desc: string;
	digits: number;
	asset: TickerAssetType;
	exchId: ExchangeType;
	atrRatio: number;
	serverId: number;
	feed: string;
}

export function getTickerNames(t: UserTickerInfo) {
	let fname: string = t.name;
	let lname: string = null;
	if (t.asset == TickerAssetType.Crypto) {
		if (t.name.endsWith('USDT')) {
			const ind = t.name.length - 4;
			fname = t.name.substring(0, ind);
			lname = t.name.substring(ind);
		}
	} else {
		if (t.name.endsWith('USD')) {
			const ind = t.name.length - 3;
			fname = t.name.substring(0, ind);
			lname = t.name.substring(ind);
		} else if (t.name.startsWith('USD')) {
			const len = 3;
			fname = t.name.substring(0, len);
			lname = t.name.substring(len + 1);
		}
	}
	return { f: fname, l: lname };
}
export interface TickerInfo extends UserTickerInfo {
	startsPrevDay: boolean;
	close: number;
	open: number;
	stat?: number;
	analytic: boolean;
}
export enum TimeFrameType {
	Min,
	Hour,
	Day,
	Week,
	Month
}
export interface TimeFrame {
	tv: string;
	disp: string;
	t: TimeFrameType;
	q: number;
	o: number;
}
